import axios from 'axios'
import store from './store'
import mixins from './mixins'
import components from './components'
//import modules from './modules'

const token = localStorage.getItem('token')
if (token) {
  axios.defaults.headers.common['X-App-Token'] = token
  axios.defaults.headers.common['Authorization'] = token
}

export default {
  _store: store,
  _mixins: mixins,
  _components: components,
  //_modules: modules
}


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/index.js
// module id = null
// module chunks = 